<template>
    <div v-if="items" class="selectorPopup">
        <div class="filter">
            <input type="text" class="filterInput" v-model="filterValue" @keyup="updateFilter()">
        </div>
        <div v-if="multiSelect" class="closeButton" @click="closeSelector()"></div>
        <div class="items" :class="multiSelect ? 'multiSelect' : ''">
            <div
                    v-if="multiSelect"
                    class="item selectAll"
                    :class="(selectAllState === 'none' ? '' : (selectAllState === 'all' ? 'selected' : 'indeterminate'))"
                    @click="selectAllClicked()"
            >Select all</div>
            <div
                    v-for="item in selectorElements"
                    class="item"
                    :class="selectedItems.includes(item.value) ? 'selected' : ''"
                    :key="item.value"
                    :value="item.value"
                    @click="itemClicked(item.value)"
            >{{item.text}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectorPopup",
        props: {
            positionLeft:    Number,
            positionTop:     Number,
            filter:          Boolean, // defines if a filter is available
            filterPreselect: Boolean, // defines a filter preset, items will be filtered initially
            filterMode:      String,  // defines a filter mode: start (default), contains
            multiSelect:     Boolean, // displays check boxes to select more than one item
            selectAll:       Boolean, // displays a select all parent selector

            items:           Array,  // elements which are displayed in the selector (could be array of strings or objects)
            itemsPreselect:  Array,  // element values which are preselected if multiSelect is true
            itemText:        String, // if items contains objects, this object value will be displayed; default = 'text'
            itemValue:       String  // if items contains objects, this object value will be returned as selected, else the displayed text will be returned (todo)
        },
        data() {
            return {
                filterValue:    this.filterPreselect || '',
                selectedItems:  this.itemsPreselect || [],
                lastSelected:   this.itemsPreselect || [],
            }
        },
        computed: {
            selectAllState() {
                if (
                    !this.multiSelect
                    || !this.itemsPreselect
                    || this.selectedItems.length === 0

                ) {
                    return 'none';
                }
                if (this.items.length === this.selectedItems.length) {
                    return 'all';
                }
                return 'some';
            },
            selectorElements() {
                let elements = [];
                for (let index in this.items) {
                    // get element
                    let element = this.items[index];
                    let elementText = element;
                    let elementValue = index;
                    if (typeof element === 'object') {
                        elementText = (this.itemText ? element[this.itemText] : element.text);
                        if (this.itemValue) {
                            elementValue = element[this.itemValue];
                        }
                    }

                    elementText = elementText + ''; // cast to string

                    // apply filter
                    if (
                        this.filter
                        && this.filterValue
                    ) {
                        if (
                            (
                                (
                                    !this.filterMode
                                    || this.filterMode === 'start'
                                )
                                && elementText.toLowerCase().indexOf(this.filterValue.toLowerCase()) === 0
                            ) || (
                                this.filterMode === 'contains'
                                && elementText.toLowerCase().includes(this.filterValue.toLowerCase())
                            )
                        ) {
                            elements.push({
                                value: elementValue,
                                text:  elementText
                            })
                        }
                    } else {
                        elements.push({
                            value: elementValue,
                            text:  elementText
                        })
                    }
                }

                return elements;
            }
        },
        methods: {
            updateFilter() {
                this.$forceUpdate();
            },
            itemClicked(itemValue) {
                if (!this.multiSelect) {
                    this.$emit('itemSelected', itemValue)
                } else {
                    let index = this.selectedItems.indexOf(itemValue);

                    if (index >= 0) {
                        // remove selection
                        this.selectedItems.splice(index, 1);
                    } else {
                        // add selection
                        this.selectedItems.push(itemValue)
                    }
                }
                this.lastSelected = this.selectedItems;
            },
            selectAllClicked() {

                let selectedItems = [];
                let selectAll = (function() {
                    for (let index in this.selectorElements) {
                        selectedItems.push(this.selectorElements[index].value);
                    }
                }).bind(this);

                let selectAllState = this.selectAllState;
                if (selectAllState === 'all') {
                    selectedItems = [];
                } else if (selectAllState === 'none') {
                    if (this.lastSelected.length > 0) {
                        // set last selected
                        selectedItems = this.lastSelected;
                    } else {
                        // set all
                        selectAll();
                    }
                } else {
                    selectAll();
                }

                this.selectedItems = selectedItems;
            },
            closeSelector() {
                this.$emit('itemSelected', this.selectedItems);
            }
        }
    }
</script>

<style scoped>
    div.selectorPopup {
        font-family: D-DIN, sans-serif;
        position: absolute;
        top: 131px;
        z-index: 10;
        left: 650px;
        background: white;
        padding: 8px;
        border: 2px solid var(--sc-blue-dark);
        border-radius: 3px;
        max-height: 75%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    div.selectorPopup div.filter {
        border-bottom: 2px solid var(--sc-blue-dark);
        padding: 4px 8px 4px 40px;
        background-image: url('../assets/icons/search.svg');
        background-position: 8px center;
        background-repeat: no-repeat;
    }

    div.selectorPopup > div.closeButton {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 8px;
        right: 8px;
        background-image: url('../assets/icons/close.svg');
        background-position: center;
    }
    div.selectorPopup > div.closeButton:hover {
        background-color: var(--sc-blue-light);
    }

    div.selectorPopup div.items {

    }

    div.selectorPopup div.items > div.item {
        padding: 8px;
    }
    div.selectorPopup div.items.multiSelect > div.item:not(.selectAll) {
        padding-left: 16px;
    }
    div.selectorPopup div.items.multiSelect > div.item {
        background-image: url('../assets/icons/check_box_unchecked.svg');
        background-size: 24px;
        background-position: 8px center;
        padding-left: 40px;
    }
    div.selectorPopup div.items.multiSelect > div.item.selected {
        background-image: url('../assets/icons/check_box_checked.svg');
    }
    div.selectorPopup div.items.multiSelect > div.item.indeterminate {
        background-image: url('../assets/icons/check_box_indeterminate.svg');
    }
    div.selectorPopup div.items.multiSelect > div.item:not(.selectAll) {
        padding-left: 56px;
        background-position: 24px center;
    }
    div.selectorPopup div.items > div.item:hover {
        background-color: var(--sc-blue-light);
    }
</style>